import React from 'react';

const DropzoneInputContext = React.createContext(null);

export const useDropzoneInput = () => React.useContext(DropzoneInputContext);

const DropzoneInputProvider = DropzoneInputContext.Provider;

export default DropzoneInputProvider;
